import { render } from "./EventTimer.vue?vue&type=template&id=90729e38&scoped=true"
import script from "./EventTimer.vue?vue&type=script&lang=js"
export * from "./EventTimer.vue?vue&type=script&lang=js"

import "./EventTimer.vue?vue&type=style&index=0&id=90729e38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-90729e38"

export default script